import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Divider } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";

import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";

import SearchFilterCard from "../../components/general/filter-card";
import BeneficiaryGroupContext from "../../context/beneficiary-groups/context";
import BeneficiaryGroupContextProvider from "../../context/beneficiary-groups/provider";
// import BeneficiaryGroupFilter from "../../components/beneficiary-groups/beneficiary-groups-filter";
import BeneficiaryGroupTable from "../../components/beneficiary-groups/beneficiary-groups-table";

const BeneficiaryGroup: React.FC = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(BeneficiaryGroupContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    if (!isMounted) actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("beneficiary_groups")}
        subTitle={t("beneficiary_groups")}
        extra={[
          <RefreshBtn
            key="refresh"
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key="divider" type="vertical" />,
          <Can key="add" perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => navigate(`/beneficiary-groups/create`)}
              icon={<PlusOutlined />}
            >
              {t("add_beneficiary_group")}
            </Button>
          </Can>,
        ]}
      />

      <SearchFilterCard
        formId="beneficiary-group-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() =>
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          })
        }
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      />

      <BeneficiaryGroupTable />
    </div>
  );
};

const BeneficiaryGroupPage = () => {
  return (
    <BeneficiaryGroupContextProvider>
      <BeneficiaryGroup />
    </BeneficiaryGroupContextProvider>
  );
};

export default BeneficiaryGroupPage;
